import type { ReactNode } from 'react'

/** Student identity in operator tables; the host owns the row destination. */
export function StudentCell({ name, email, client }: {
  name: ReactNode
  email: string
  client: string
}): JSX.Element {
  return <>{name}<span className="block text-table-secondary text-text-secondary">{email}<br />{client}</span></>
}
